import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/design-system/components/primitives/button'

/**
 * Pagination — постраничная навигация списка (`component.pagination`, centrika-docs!43):
 * «Назад», «Страница X из Y», «Вперёд». Компонент презентационный: страницу хранит и
 * меняет вызывающая сторона (она же грузит данные и сохраняет фильтры/поиск).
 *
 * Если страница одна (или меньше), компонент НЕ отображается — требование.
 */
export interface PaginationProps {
  /** Текущая страница, нумерация с 1. */
  page: number
  /** Общее количество страниц. */
  totalPages: number
  onChange: (page: number) => void
  className?: string
}

export function Pagination({ page, totalPages, onChange, className }: PaginationProps) {
  if (totalPages <= 1) return null
  return (
    <nav
      aria-label="Постраничная навигация"
      className={cn('flex items-center justify-center gap-3 py-3', className)}
    >
      <Button
        size="sm"
        variant="secondary"
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        leftIcon={<ChevronLeft className="size-4 stroke-current" aria-hidden />}
      >
        Назад
      </Button>
      <span className="text-13 text-txt-secondary">
        Страница {page} из {totalPages}
      </span>
      <Button
        size="sm"
        variant="secondary"
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        rightIcon={<ChevronRight className="size-4 stroke-current" aria-hidden />}
      >
        Вперёд
      </Button>
    </nav>
  )
}
